export function getDefaultDevice(
  devices: MediaDeviceInfo[],
): MediaDeviceInfo | undefined {
  return devices.find((device) => device.deviceId === "default");
}
